<template>
    <div>
        <form data-vv-scope="member">
            <form data-vv-scope="profile">
                <span class="text-lg font-semibold">{{ $t("profile") }}</span>
                <div :class="classForDOM.block">
                    <MultiselectCustom
                        endpoint="user/relation-degrees/"
                        :placeholder="`${$t('relation_degree')}*`"
                        v-validate="'required'"
                        @selected="getObjectProfile"
                        v-model="relation_degree"
                        name="relation_degree"
                    />
                    <ValidateText
                        field="relation_degree"
                        scope="profile"
                        :error="errors"
                    />
                </div>
                <div :class="classForDOM.grandParent">
                    <div :class="classForDOM.block">
                        <vs-input
                            :label-placeholder="`${$t('last_name')}*`"
                            v-validate="'required'"
                            name="last_name"
                            v-model="profile.last_name"
                            class="mt-8 flex-auto p-1 w-full"
                        />
                        <ValidateText
                            field="last_name"
                            scope="profile"
                            :error="errors"
                        />
                    </div>
                    <div :class="classForDOM.block">
                        <vs-input
                            :label-placeholder="`${$t('first_name_true')}*`"
                            v-validate="'required'"
                            name="first_name"
                            v-model="profile.first_name"
                            class="mt-8 flex-auto p-1 w-full"
                        />
                        <ValidateText
                            field="first_name"
                            scope="profile"
                            :error="errors"
                        />
                    </div>
                    <div :class="classForDOM.block">
                        <vs-input
                            :label-placeholder="`${$t('middle_name')}`"
                            name="middle_name"
                            v-model="profile.middle_name"
                            class="mt-8 flex-auto p-1 w-full"
                        />
                    </div>
                </div>
                <div :class="classForDOM.grandParent">
                    <div :class="classForDOM.block">
                        <vs-input
                            :label-placeholder="`${$t('email')}*`"
                            v-validate="'required|email'"
                            name="email"
                            v-model="profile.email"
                            class="mt-8 flex-auto p-1 w-full"
                        />
                        <ValidateText
                            field="email"
                            scope="profile"
                            :error="errors"
                        />
                    </div>
                    <div :class="classForDOM.block">
                        <vs-input
                            :label-placeholder="`${$t('workplace')}`"
                            name="workplace"
                            v-model="profile.workplace"
                            class="mt-8 flex-auto p-1 w-full"
                        />
                    </div>
                    <div :class="classForDOM.block">
                        <vs-input
                            :label-placeholder="`${$t('position')}`"
                            name="position"
                            v-model="profile.position"
                            class="mt-8 flex-auto p-1 w-full"
                        />
                    </div>
                </div>
                <!-- <div :class="classForDOM.grandParent" v-if="!profile.uid">
                    <vs-button
                        type="relief"
                        class="w-full mt-8"
                        @click="getObjectProfile"
                        >{{ $t("save_profile") }}</vs-button
                    >
                </div> -->
                <vs-divider />
            </form>

            <template >
                <form data-vv-scope="phone">
                    <span class="text-lg font-semibold">{{
                        $t("phone_number")
                    }}</span>
                    <PhoneAnother
                        :applicantNoProfileUid="applicantNoProfileUid"
                        :data="phoneData"
                        :profileUid="applicantUid"
                        ref="phone_another"
                    />
                    <vs-divider />
                </form>

                <div>
                    <div :class="classForDOM.parent" class="mb-8">
                        <span class="text-lg font-semibold">{{
                            $t("address")
                        }}</span>
                    </div>

                    <div :class="classForDOM.parent" class="ml-2">
                        <div :class="classForDOM.block">
                            <ul class="leftx">
                                <li class="mb-2">
                                    <vs-radio
                                        v-model="memberAddressStatus"
                                        vs-name="radios1"
                                        vs-value="registration"
                                        :disabled="!dataOfApplicant.addresses.registration"
                                        >{{
                                            $t(
                                                "family_registration_of_resident"
                                            )
                                        }}</vs-radio
                                    >
                                </li>
                                <li class="mb-2">
                                    <vs-radio
                                        v-model="memberAddressStatus"
                                        vs-name="radios1"
                                        vs-value="temporal"
                                        :disabled="!dataOfApplicant.addresses.temporal"
                                        >{{
                                            $t("family_temporal_of_resident")
                                        }}</vs-radio
                                    >
                                </li>
                                <li class="mb-2">
                                    <vs-radio
                                        v-model="memberAddressStatus"
                                        vs-name="radios1"
                                        vs-value="residence"
                                        :disabled="!dataOfApplicant.addresses.residence"
                                        >{{ $t("family_resident") }}</vs-radio
                                    >
                                </li>
                                <li class="mb-2">
                                    <vs-radio
                                        v-model="memberAddressStatus"
                                        vs-name="radios1"
                                        vs-value="family_new_resident"
                                        >{{
                                            $t("family_new_resident")
                                        }}</vs-radio
                                    >
                                </li>
                            </ul>
                            <span
                                class="text-danger text-sm"
                                v-if="!memberAddressStatus"
                            >
                                {{ $t("please_change_type_resident") }}
                            </span>
                        </div>
                    </div>

                    <template
                        v-if="memberAddressStatus === 'family_new_resident'"
                    >
                        <AddressForm
                            :profile-uid="profile.uid"
                            :applicantNoProfileUid="applicantNoProfileUid"
                            :data="addressData"
                            :typeUid="typesAddress['RES']"
                            ref="address"
                        />
                    </template>
                    <vs-divider></vs-divider>
                </div>
                <div :class="classForDOM.grandParent">
                    <vs-button
                        type="relief"
                        class="w-full mt-8"
                        @click="saveMember"
                        >{{ $t("save_member") }}</vs-button
                    >
                </div>
            </template>
        </form>
    </div>
</template>

<script>
import MultiselectCustom from "@/pages/Home/FillingInTheApplicantsData/widgets/MultiselectCustom";
import ValidateText from "@/pages/Home/FillingInTheApplicantsData/widgets/ValidateText";
import PhoneAnother from "@/pages/Home/FillingInTheApplicantsData/Questionnaire/components/PhoneAnother";
import AddressForm from "@/pages/Home/FillingInTheApplicantsData/Questionnaire/components/AddressForm";
export default {
    name: "FamilyMemberForm",
    components: {
        MultiselectCustom,
        ValidateText,
        PhoneAnother,
        AddressForm,
    },
    props: {
        familyUid: {
            type: String,
            required: true,
        },
        applicantUid: {
            type: String,
            required: false,
            default: null,
        },
        profileAbuterentUid: {
            type: String,
            required: true,
        },
        applicantNoProfileUid: {
            type: String,
            required: true,
        },
        dataOfApplicant: {
            type: Object,
            required: true,
        },
        data: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            relation_degree: null,
            profile: {
                first_name: "",
                last_name: "",
                middle_name: "",
                email: "",
                workplace: "",
                position: "",
                applicant: this.applicantNoProfileUid,
                uid: "",
            },
            familyMemberUid: null,
            phoneData: null,
            addressData: null,
            memberAddressStatus: null,
            classForDOM: {
                grandParent: "flex flex-col md:flex-row justify-between",
                parent: "flex flex-col md:flex-row justify-between items-start",
                block: "flex flex-col w-full",
            },
            typesAddress: null,
            uid_profile_phone:''
        };
    },
    methods: {
        async saveMember() {
            this.$vs.loading();
            let clone = await this.getObjectProfile()
            if (
                // Проверка и сохранение профиля
                (clone.true_false) &&
                // Проверка и сохранение телефона
                (await this.$refs.phone_another.validateStep(clone.uid_profile_phone)) &&
                // Проверка адреса и сохранение, если это новый адрес(то бишь должен быть срендерен компонент адреса)
                (!this.$refs.address ||
                    (this.$refs.address &&
                        (await this.$refs.address.validateStep())))
            ) {

                if (this.memberAddressStatus !== "family_new_resident") {
                    // dataOfApplicant addresses
                    let clone = null;
                    clone = {
                        ...this.dataOfApplicant.addresses[
                            this.memberAddressStatus
                        ],
                    };


                    clone.type = await this.typesAddress["RES"];
                    clone.profile = this.profile.uid;

                    const response = (
                        await this.$http.post("admissions/addresses/", clone)
                    ).data;
                }

                // (

                //     await this.$http.patch(
                //         `admissions/members/${ this.familyMemberUid }/`,
                //         {
                //             address_matches: this.memberAddressStatus,
                //         }
                //     )
                // ).data;
                const listMembers = (
                    await this.$http.get("admissions/members/my/", {
                        params: {
                            profile: this.profileAbuterentUid,
                        },
                    })
                ).data;

                this.$emit("setNewListMembers", listMembers);

                this.$emit("closeModal");

                this.$emit("clearObjectOfMemberForEdit");
                this.$vs.loading.close();

                return true;
            } else {
                this.$vs.loading.close();

                return false;
            }

        },
        async connectMemberInApplicant() {
            try {
                const response = (
                    await this.$http.post("admissions/members/", {
                        family: this.familyUid,
                        relation_degree: this.relation_degree,
                        profile: this.profile.uid,
                        applicant: this.profileAbuterentUid,
                    })
                ).data;

                this.familyMemberUid = response.uid;
            } catch (e) {
            } finally {
            }
        },
        async  getObjectProfile() {
            return this.$validator
                .validateAll("profile")
                .then(async (result) => {
                    if (result) {
                        const newProfile = this.profile.uid;

                        const response = (
                            await this.$http[newProfile ? "put" : "post"](
                                `admissions/profiles/${
                                    newProfile ? newProfile + "/" : ""
                                }`,
                                {
                                    ...this.profile,
                                    applicant: this.applicantNoProfileUid,
                                }
                            )
                        ).data;

                        // Если это создание, то делаю связку профиля с абиком моментально
                        if (!newProfile) {
                            this.profile.uid = response.uid;
                            await this.connectMemberInApplicant();
                        }
                        this.uid_profile_phone = response.uid
                        // console.log({true_false:true,uid_profile_phone:response.uid})
                        return {'true_false':true,'uid_profile_phone':response.uid};
                    } else {
                        return {'true_false':false,'uid_profile_phone':''};
                    }
                });
        },
        async getTypesAddress() {
            try {
                this.$vs.loading();

                const response = (await this.$http.get("user/address-types/"))
                    .data;

                let object = {};

                for (let i = 0; i < response.length; i++) {
                    let e = response[i];
                    object[e.code] = e.uid;
                }

                this.typesAddress = object;
            } catch (e) {
            } finally {
                this.$vs.loading.close();
            }
        },
    },
    created() {
        this.getTypesAddress();
        if (this.data) {
            for (let key in this.profile) {
                this.profile[key] = this.data.profile[key];
            }

            this.relation_degree = this.data.relation_degree;
            this.phoneData = this.data.phone;
            this.addressData = this.data.address;
            this.memberAddressStatus = this.data.address_matches;
            this.familyMemberUid = this.data.uid;
        }
    },
    destroyed() {
        this.$emit("clearObjectOfMemberForEdit");
    },
};
</script>

<style scoped lang="scss">
</style>
